/* eslint-disable react-hooks/exhaustive-deps */
import { faCaretDown, faCaretUp, faUpload } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, Button, CircularProgress, Collapse, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import { FC, useEffect, useState } from "react";
import { Formater, TypeRecords } from "src/framework/commons/Formater";
import { LocalStorage } from "src/framework/commons/LocalStorage";
import { FullWidthButton } from "src/framework/components/buttons/FullWidthButton";
import { InputText } from "src/framework/components/forms/inputs/InputText";
import { apiNoLoading, IDataRequest, IDataResponse, STATUS_CODE } from "src/framework/providers/api";
import { notifierStore } from "src/framework/store/NotifierStore";
import defaultListStore from "src/framework/store/DefaultListStore";
import theme from "src/theme/light";
import { Verticais } from "../../types";
import { resolveProtocolUrl } from "src/store/global.store";
import { downloadDocumento } from "src/components/componentes/forms/Documentos";
import { Upload } from "src/components/componentes/types";

type DocVerticaisType = "proposta" | "componentes"


interface DialogAddDocsRowProperties {

    codigoProjeto: string;
    tipo: DocVerticaisType;
    disabled: boolean;
    onChange: (file: File, versaoRevisao: string) => void;
}

const DialogAddDocsRow: FC<DialogAddDocsRowProperties> = ({
    codigoProjeto,
    tipo,
    disabled = false,
    onChange,
}) => {
    const [fileName, setFileName] = useState<string>("")
    const id = `select-${tipo}-${codigoProjeto}`

    return (
        <TableRow>
            <TableCell>{`${tipo}`}</TableCell>
            <TableCell width={300}>{fileName}</TableCell>
            <TableCell align="right">
                <input
                    accept={tipo === "proposta" ? ".pdf" : ".xlsx"}
                    type="file"
                    id={id}
                    style={{ display: 'none' }}
                    disabled={disabled}
                    onChange={(e) => {
                        if (e.target.files !== null) {
                            const file = e.target?.files[0];
                            const regex = /([a-zA-Z0-9.-]{1,})(\d{2,}-\d{2,}(?=\.))(\.xlsx|\.pdf)/

                            const versaoRevisao = file.name.replace(regex, '$2');
                            setFileName(file.name);
                            if (regex.exec(file.name) === null) {

                                notifierStore.setNotifier({
                                    title: "Aviso!",
                                    content: `Nome do arquivo fora do padrão. Ex: ABC123.01-01.xlsx|.pdf`,
                                    timeOut: 2000,
                                    onClose: () => {
                                        notifierStore.setOpen(false);
                                    }
                                })
                                notifierStore.setOpen(true);
                                return;
                            }
                            onChange(e.target?.files[0], versaoRevisao);
                        }
                    }}
                />
                <label htmlFor={id}>
                    <Button size="small" variant="text" color="secondary" component="span" disabled={disabled}>
                        <FontAwesomeIcon icon={faUpload} size="xs" />
                    </Button>
                </label>
            </TableCell>
        </TableRow>
    );
}

interface DialogAddDocsProperties {
    codigoProjeto: string;
    open: boolean;
    onClose: () => void
    onChange: (proposta: any, componente: any, informacaoInstrucao: string) => void
}


const DialogAddDocs: FC<DialogAddDocsProperties> = ({
    codigoProjeto,
    open,
    onClose,
    onChange
}) => {
    const [uploading, setUploading] = useState<boolean>(false);
    const [propostaFile, setPropostaFile] = useState<File | null>(null);
    const [componenteFile, setComponenteFile] = useState<File | null>(null);
    const [versaoRevisaoProposta, setVersaoRevisaoProposta] = useState<string>("");
    const [versaoRevisaoComponente, setVersaoRevisaoComponente] = useState<string>("");
    const [error, setError] = useState<boolean>(false);
    const [informacaoInstrucao, setInformacaoInstrucao] = useState<string>("");

    const uploadProposta = async (): Promise<any> => {
        const regex = /([a-zA-Z0-9.-]{1,})(\d{2,}-\d{2,}(?=\.))(\.xlsx|\.pdf)/
        if (propostaFile) {

            const versaoRevisao = propostaFile.name.replace(regex, '$2');
            const form = new FormData();
            const extension: string = propostaFile.name.replace(regex, '$3');

            if (versaoRevisao && extension !== "") {
                form.append(`proposta.${versaoRevisao}${extension}`, propostaFile, propostaFile.name);
                const url: string = `/projetos/uploads/${codigoProjeto}?tipo=vertical`;

                const request: IDataRequest = {
                    url: url,
                    data: form,
                }

                return apiNoLoading.post(request)
            }
        }
    }

    const uploadComponente = async (): Promise<any> => {
        const regex = /([a-zA-Z0-9.-]{1,})(\d{2,}-\d{2,}(?=\.))(\.xlsx|\.pdf)/
        if (componenteFile) {

            const versaoRevisao = componenteFile.name.replace(regex, '$2');
            const form = new FormData();
            const extension: string = componenteFile.name.replace(regex, '$3');

            if (versaoRevisao && extension !== "") {
                form.append(`proposta.${versaoRevisao}${extension}`, componenteFile, componenteFile.name);
                const url: string = `/projetos/componentes/adicionar/${codigoProjeto}`;

                const request: IDataRequest = {
                    url: url,
                    data: form,
                }

                return apiNoLoading.post(request)
            }
        }
    }

    const handleUpload = async (): Promise<void> => {
        try {
            if (versaoRevisaoComponente !== "" && versaoRevisaoProposta !== "" && versaoRevisaoComponente !== versaoRevisaoProposta) {
                notifierStore.setNotifier({
                    title: "Aviso!",
                    content: "Por favor selecione os arquivos com a mesma versão e revisão!",
                    timeOut: 2000,
                    onClose: () => {
                        notifierStore.setOpen(false);
                    }
                })
                notifierStore.setOpen(true);
                return;
            }

            setUploading(true)

            const responseComponente: IDataResponse = await uploadComponente();

            if (responseComponente.statusCode !== STATUS_CODE.OK) {
                setError(true)
                return;
            }

            const responseProposta: IDataResponse = await uploadProposta();

            if (responseProposta.statusCode !== STATUS_CODE.OK) {
                setError(true)
                return;
            }

            const propostaData = responseProposta.data[Object.keys(responseProposta.data)[0]];
            const componenteData = responseComponente.data

            onChange(propostaData, componenteData, informacaoInstrucao)
            setPropostaFile(null)
            setComponenteFile(null);
            onClose();
        } catch (e) {
            //TO DO: Verificar tratamento de erro

        } finally {
            setUploading(false)
        }
    }


    return <>
        <Dialog open={open} >
            <DialogTitle id="dialog-verticais-docs-add">Carregar documentos</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    <strong>Faça o upload dos arquivos de proposta e componentes</strong>
                    <p>Os arquivos devem ter a mesma versão e revisão. Opcionalmente poderá ser informado uma informação/instrução para esta proposta.</p>
                </DialogContentText>
            </DialogContent>
            <Box mx={1}>
                <InputText
                    multiline
                    label="Informação/Instrução da proposta"
                    fullWidth
                    maxRows={5}
                    minRows={1}
                    value={informacaoInstrucao}
                    InputProps={{
                        rows: 1
                    }}
                    onChange={(event: any) => {
                        setInformacaoInstrucao(event?.target?.value);
                    }}
                />
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>Tipo</TableCell>
                            <TableCell>Arquivo</TableCell>
                            <TableCell></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <DialogAddDocsRow
                            tipo={"proposta"}
                            codigoProjeto={codigoProjeto}
                            disabled={uploading}
                            onChange={(file, versaoRevisao) => {
                                setPropostaFile(file)
                                setError(false);
                                setVersaoRevisaoProposta(versaoRevisao)
                            }}
                        />
                        <DialogAddDocsRow
                            tipo={"componentes"}
                            disabled={uploading}
                            codigoProjeto={codigoProjeto}
                            onChange={(file, versaoRevisao) => {
                                setComponenteFile(file)
                                setError(false);
                                setVersaoRevisaoComponente(versaoRevisao)
                            }}
                        />
                    </TableBody>
                </Table>
            </Box>
            <DialogActions>
                <Button
                    disabled={uploading}
                    onClick={() => {
                        setPropostaFile(null);
                        setComponenteFile(null);
                        onClose()
                    }}>
                    Cancelar
                </Button>
                <Button
                    color="primary"
                    variant="contained"
                    disableElevation
                    disabled={!propostaFile || !componenteFile || uploading || error}
                    onClick={() => {
                        handleUpload()
                    }}
                >
                    {uploading ? <><CircularProgress variant="indeterminate" size={20} /></> : "Ok"}
                </Button>

            </DialogActions>
        </Dialog>
    </>
}

interface DocVerticaisRowProperties {
    idProjeto: string;
    codigoProjeto: string;
    upload: Upload | null;
    tipo: DocVerticaisType;
}

const DocVerticaisRow: FC<DocVerticaisRowProperties> = ({
    idProjeto,
    codigoProjeto,
    upload,
    tipo,
}) => {

    const [historico, setHistorico] = useState<any>([]);
    const [expand, setExpand] = useState<boolean>(false);


    const getHistorico = async (): Promise<void> => {
        const request: IDataRequest = {
            url: `/projetos/uploads/historico?projeto_id=${idProjeto}&tipo=${tipo}&orderby=created_at-desc`
        }

        const response: IDataResponse = await apiNoLoading.get(request);

        if (response.statusCode === STATUS_CODE.OK) {
            setHistorico(response.data)
        }
    }

    const parseFileName = (url: string): string => {
        let fileName = url.split("/");
        return fileName.pop() || "";

    }

    const parseTipoUpload = (tipo: DocVerticaisType): string => {
        switch (tipo) {
            case "proposta":
                return "Proposta";
            case "componentes":
                return "Componentes";
        }
    }

    const parseSituacao = () => {
        if (upload !== null && !Object.keys(upload).includes("created_at")) {
            return <span style={{ color: theme.palette.warning.main }}>Não salvo</span>
        }

        if (upload === null || upload === undefined) {
            return <span style={{ color: theme.palette.text.disabled }}>Sem arquivo</span>
        }

        if (upload?.url !== "") {
            return <span style={{ color: theme.palette.primary.main }}>Ok</span>
        }

        return ""
    }

    useEffect(() => {
        if (idProjeto !== 'undefined') {
            getHistorico();
        }
    }, [])

    return (
        <>
            <TableRow>
                <TableCell width={300}>
                    <Button
                        variant="text"
                        color="secondary"
                        disabled={upload === null}
                        onClick={() => {
                            if (upload) {
                                const regex = /([a-zA-Z0-9.\-/]{1,})(\d{2,}-\d{2,}(?=\.))(\.xlsx|\.pdf)/

                                const versaoRevisao = String(upload?.url).replace(regex, '$2');

                                const nomeArquivo = `${tipo}-${codigoProjeto}-${versaoRevisao}`
                                const path: string = (upload as any)?.path || upload.url

                                let uploadBaseUrl = defaultListStore.uploadUrl;

                                if (!uploadBaseUrl) {
                                    uploadBaseUrl = LocalStorage.get("solar.uploadInfo", true)?.data?.url || "";
                                }

                                downloadDocumento(resolveProtocolUrl(`//${uploadBaseUrl}${path}`), tipo, nomeArquivo);
                            }
                        }}
                    >
                        {upload?.url ? parseFileName(upload?.url || "") : parseTipoUpload(tipo)}
                    </Button>
                </TableCell>
                <TableCell width={300}>{parseSituacao()}</TableCell>
                <TableCell width={300}>{upload?.observacao || ""}</TableCell>
                <TableCell width={20} align="right" >
                    {idProjeto && historico?.length > 0 ? <>
                        <IconButton onClick={() => setExpand(!expand)} size="small">
                            <FontAwesomeIcon icon={expand ? faCaretUp : faCaretDown} size="sm" />
                        </IconButton>
                    </> : ""}
                </TableCell>
            </TableRow>
            {idProjeto && historico?.length > 0 ? <>
                <TableRow style={{ width: "100%" }}>
                    <TableCell colSpan={3} width="100%" style={{ padding: "0px", borderBottom: "none" }}>
                        <Collapse in={expand} style={{ width: "100%" }}>
                            <div>
                                <Table size="small" style={{ backgroundColor: theme.palette.grey[50] }}>
                                    <TableBody>
                                        {historico?.map((h: any, index: number) => {

                                            const regex = /([a-zA-Z0-9.\-/]{1,})(\d{2,}-\d{2,}(?=\.))(\.xlsx|\.pdf)/

                                            const versaoRevisao = String(h?.url).replace(regex, '$2');

                                            const nomeArquivo = `${tipo}-${codigoProjeto}-${versaoRevisao}`

                                            return (
                                                <>
                                                    <TableRow key={`verticais-form-componentes-historico-${idProjeto}-${index}`}>
                                                        <TableCell width={300}>
                                                            <Button
                                                                variant="text"
                                                                onClick={() => {
                                                                    downloadDocumento(resolveProtocolUrl(`//${defaultListStore.uploadUrl}${h?.url}`), tipo, nomeArquivo);
                                                                }}>
                                                                {h?.url ? parseFileName(h?.url || "") : parseTipoUpload(tipo)}
                                                            </Button>
                                                        </TableCell>
                                                        <TableCell width={300} align="right">Histórico {Formater.toString(h.created_at, TypeRecords.DATE_TIME)}</TableCell>
                                                    </TableRow>
                                                </>
                                            );
                                        })}
                                    </TableBody>
                                </Table>
                            </div>
                        </Collapse>
                    </TableCell>
                </TableRow>
            </>
                : ""}
        </>
    );
}

interface DocsVerticaisProperties {
    projeto: Verticais | null;
    proposta: Upload | null;
    componentes: Upload | null;
    disabled?: boolean;
    onChange: (proposta: any, componentes: any, informacaoInstrucao: string) => void;
}

const DocsVerticais: FC<DocsVerticaisProperties> = ({
    projeto,
    proposta,
    componentes,
    disabled = false,
    onChange
}) => {
    const [openDialog, setOpenDialog] = useState<boolean>(false);
    const [propostaUploadState, setPropostaUploadState] = useState<any>(null)
    const [componenteUploadState, setComponenteUploadState] = useState<any>(null)


    const handleOpenDialog = (): void => {
        setOpenDialog(true);
        return;
    }

    useEffect(() => {
        setPropostaUploadState(proposta);
        setComponenteUploadState(componentes);
    }, [])

    useEffect(() => {
        if (proposta) {
            setPropostaUploadState(proposta)
        }
    }, [proposta]);

    useEffect(() => {
        if (componentes) {
            setComponenteUploadState(componentes)
        }
    }, [componentes]);

    return <>
        <div className="row">
            <div className="X12">
                <TableContainer>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>Tipo</TableCell>
                                <TableCell>Situação</TableCell>
                                <TableCell>Informação/Instrução da proposta</TableCell>
                                <TableCell align="right" width={100} padding="none">
                                    <FullWidthButton
                                        variant="outlined"
                                        disabled={disabled}
                                        text="Adicionar"
                                        onClick={() => handleOpenDialog()}
                                    />
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            <DocVerticaisRow
                                idProjeto={`${projeto?.id}`}
                                codigoProjeto={`${projeto?.codigo_venda || 0}`}
                                tipo="proposta"
                                upload={propostaUploadState}
                            />
                            <DocVerticaisRow
                                idProjeto={`${projeto?.id}`}
                                codigoProjeto={`${projeto?.codigo_venda || 0}`}
                                tipo="componentes"
                                upload={componenteUploadState}
                            />
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>
        </div>
        <DialogAddDocs
            codigoProjeto={`${projeto?.codigo_venda || 0}`}
            onChange={(proposta, componente, informacaoInstrucao) => {
                setPropostaUploadState(proposta)
                if (componente?.upload) {
                    setComponenteUploadState(componente.upload[Object.keys(componente.upload)[0]])
                }
                onChange(proposta, componente, informacaoInstrucao)
            }}
            open={openDialog}
            onClose={() => {
                setOpenDialog(false)
            }}
        />
    </>
}


export { DocsVerticais }